import React, { useEffect, useRef } from 'react'
import Footer from './footer'
import Banner from './section/banner'
import Topcategories from './section/top-categories'
import Feature from './section/feature'
import Masterskill from './section/master-skill'
import Trendingcourse from './section/trending-course'
import Leadingcompany from './section/leading-company'
import Knowledge from './section/knowledge'
import Testimonial from './section/testimonial'
import Becomeinstructor from './section/become-instructor'
import Latestblog from './section/latest-blog'
import Benefits from './section/benefits'
import Ourservices from './section/ourServices'
import EducationDestination from './section/education-destination'
import YourStudyAbroadSteps from './section/your-study-abroad-steps'
import StartTestimonials from './section/startTestimonials'
import StudyEssentials from './section/studyEssentials'
import FAQ from './section/faq'
import Unlock from "./section/Unlock"
import AOS from 'aos';
import 'aos/dist/aos.css';
import { useGetHomepageApiQuery } from '../../../core/Features/api/homepage/homePageApi';
import { useDispatch } from 'react-redux'
import { setCommonData } from '../../../core/Features/commonSlice'


const HomePalani = () => {
  const { data, isLoading, isError } = useGetHomepageApiQuery({});
  const seventhRef = useRef<HTMLDivElement>(null);

  const handleScrollToSeventh = () => {
    seventhRef.current?.scrollIntoView({ behavior: 'smooth' });
  };

  const dispatch = useDispatch()

  useEffect(() => {

    dispatch(setCommonData({
      allTestimonials: {
        topdata: data?.data?.testimonials,
        allVideosTestimonials: data?.testimonials

      }
    }));


  }, [data])
  useEffect(() => {
    AOS.init({
      duration: 1000, // animation duration
      once: true,     // animate only once
    });
  }, []);
  return (
    <>
      <Banner scrollToSeventh={handleScrollToSeventh} apiValues={data?.data?.carousel || []} miniBannerValues={data?.data?.miniCard || []} extraVal={data?.data?.rightSideImageUrl} />
      <Unlock />
      <Benefits apiValues={data?.data?.whyPalanivel || {}} />
      <Leadingcompany apiValues={data?.data?.trustedBy || {}} />
      <Ourservices apiValues={data?.data?.ourServices || {}} />
      <div ref={seventhRef}>
        <EducationDestination apiValues={data?.destinations || {}} apiValues2={data?.data?.educationDestination || []} />
      </div>

      <YourStudyAbroadSteps apiValues={data?.data?.stpesToimplement || {}} />
      <StartTestimonials />
      {/* <div className='-mt-28'> */}
      <StudyEssentials apiValues={data?.data?.serviceToStudents || {}} />
      {/* </div> */}
      <FAQ apiValues={data?.data?.faq || {}} />

      {/* <Topcategories /> */}
      {/* <Feature /> */}
      {/* <Masterskill /> */}
      {/* <Trendingcourse /> */}
      {/* <Knowledge /> */}
      {/* <Testimonial /> */}
      <Becomeinstructor apiValues={data?.data?.bottomTwoCard || {}} />
      {/* <Latestblog /> command */}
      {/* <Footer /> */}
    </>
  )
}

export default HomePalani
